import React from 'react';
import { pains, painBridge } from '../data/tables';
export function PainGrid() {
  return <section aria-labelledby="pain-heading" className="bg-paper" data-id="element-151" data-mp="1zex39avlbj4s">
      <div className="mx-auto max-w-content px-5 py-16 sm:px-8 md:py-28" data-id="element-152" data-mp="1zhrmx06s4zx5">
        <h2 id="pain-heading" className="mx-auto max-w-[42rem] text-center font-serif text-[28px] font-semibold leading-[1.15] tracking-[-0.01em] text-ink md:text-[42px]" data-id="element-153" data-mp="1un5i5fv7e5m1">
          If any of this happened to you this month, it is not because you are disorganized.
        </h2>

        <ul className="mt-14 grid gap-x-12 gap-y-6 md:grid-cols-2" data-id="element-154" data-mp="1gnmdwy5ijef0">
          {pains.map(pain => <li key={pain} className="flex gap-4 border-b border-brass/20 pb-6" data-id="element-155" data-mp="1brxb8ly75heh">
              <span aria-hidden="true" className="mt-[3px] font-mono text-[15px] font-medium leading-none text-brick" data-id="element-156" data-mp="17ptyzv3pe8s5">
                ✗
              </span>
              <p className="text-[17px] leading-[1.6] text-slate" data-id="element-157" data-mp="3231w5tf5iwgy">{pain}</p>
            </li>)}
        </ul>

        <p className="mx-auto mt-14 max-w-[38rem] text-center font-serif text-[22px] italic leading-[1.4] text-ink md:text-[26px]" data-id="element-158" data-mp="3gb6897ncmi55">
          {painBridge}
        </p>
      </div>
    </section>;
}